import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PhotoUploaderModule } from '@classifieds-sell/trademe-core-ui';
import { TgGridModule, TgBoxes2Module } from '@trademe/tangram';
import { MotorsDescriptionAndPhotosPhotoSectionComponent } from './motors-description-and-photos-photo-section.component';

@NgModule({
    imports: [CommonModule, TgGridModule, TgBoxes2Module, FormsModule, PhotoUploaderModule],
    declarations: [MotorsDescriptionAndPhotosPhotoSectionComponent],
    exports: [MotorsDescriptionAndPhotosPhotoSectionComponent]
})
export class MotorsDescriptionAndPhotosPhotoSectionModule {}
